/**
 * Returns true when the `adb2c=true` cookie is present.
 *
 * Setting document.cookie = "adb2c=true; path=/" in the browser console
 * (or via a deployment script) switches the auth provider from Auth0 to
 * Azure AD B2C without requiring a redeploy.
 *
 * Default (no cookie): Auth0
 * Cookie `adb2c=true`:  Azure AD B2C
 */
export function isAdb2cEnabled() {
  return document.cookie.split(';').some((c) => c.trim() === 'adb2c=true');
}
